import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch, convertFormatToTableColumnFormat } from '@blaze-runtime/engine-domain';
import { type ColumnFormatInfo } from '@blaze-shared/api-contracts-domain';

import { type FormFieldGenerationParams } from '../../__base/generation';
import { type SliderFormat } from '../slider.models';
import { dataValueToInternal, toSliderFormat } from '../slider.utils';

export function generateSliderFormField(
  params: FormFieldGenerationParams<'slider'>,
): PartialPropsOf<'slider'> {
  let props: PartialPropsOf<'slider'> = applyPropsPatch(params.props, {
    style: { general: { offset: { margin: '$t.spacingFormField' } } },
  });

  const { column } = params.inputData;
  const inputDataType = column.dataType;
  const format = inputDataType === 'Number' ? convertFormatToSliderFormat(column.format) : 'number';

  const defaultValue = column.defaultValue;
  if (typeof defaultValue === 'number' && !Number.isNaN(defaultValue)) {
    props = applyPropsPatch(props, {
      content: { options: { defaultValue: dataValueToInternal(defaultValue, format) } },
    });
  }

  if (inputDataType === 'Number') {
    props = applyPropsPatch(props, {
      content: {
        options: {
          format,
          currency: column.format?.currencySymbol,
          precision: column.precision,
          ...(format === 'percentage' ? { min: 0, max: 100 } : {}),
        },
      },
    });
  }

  if (params.inputData.readonly) {
    props = applyPropsPatch(props, { content: { options: { readonly: true } } });
  }

  return props;
}

const convertFormatToSliderFormat = (format: ColumnFormatInfo | undefined): SliderFormat => {
  if (!format) {
    return 'number';
  }
  return toSliderFormat(convertFormatToTableColumnFormat(format.formatType)) ?? 'number';
};
